import React from 'react';
import styled from 'styled-components';

type TypeOfBgProps = {
  value?: 'status' | 'staff';
  onChange?: (value: string) => void;
};

const TypeOfBg = ({ value, onChange }: TypeOfBgProps) => {
  return (
    <Container>
      <div
        className={`item ${value === 'status' ? 'active' : ''}`}
        onClick={() => onChange?.('status')}
      >
        Status
      </div>
      <div
        className={`item ${value === 'staff' ? 'active' : ''}`}
        onClick={() => onChange?.('staff')}
      >
        Staff
      </div>
    </Container>
  );
};

export default TypeOfBg;

const Container = styled.div`
  display: flex;
  width: 100%;
  .item {
    flex: 1;
    display: flex;
    height: 72px;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    border-bottom: 1px solid #86909c;
    color: #505050;
    text-align: center;
    font-size: 24px;
    font-weight: 600;
    transition: all 0.3s ease;
    &.active {
      color: #2d6772;
      border-bottom: 3px solid #2d6772;
    }
  }
`;
